import { render, staticRenderFns } from "./SectionComponent.vue?vue&type=template&id=c7a530ec&scoped=true&"
import script from "./SectionComponent.vue?vue&type=script&lang=js&"
export * from "./SectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SectionComponent.vue?vue&type=style&index=0&id=c7a530ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a530ec",
  null
  
)

export default component.exports